import { Typography, Units, Shadow, Colors } from 'Css';

const css = oxygenCss({
  root: {
    marginBottom: Units.base * 2,
    overflow: 'hidden'
  },
  edit: {
    backgroundColor: Colors.fullWhite,
    borderRadius: 5,
    boxShadow: Shadow[1],
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.05)',
    borderWidth: 1
  },
  container: {
    padding: 20
  },
  panel: {
    textAlign: 'center',
    padding: Units.keyline / 2
  },
  leftToolbarGroup: {
    minWidth: 64,
    verticalAlign: 'middle'
  },
  toolbarHeader: {
    color: Colors.creen
  },
  progress: {
    color: Colors.creen,
    fontSize: Typography.subheading.fontSize,
    letterSpacing: Typography.subheading.letterSpacing,
    fontFamily: Typography.subheading.fontFamily,
    lineHeight: Typography.subheading.lineHeight
  },
  buttonContainer: {
    padding: Units.base / 2
  },
  pad: {
    margin: `${Units.base * 2}px 0`
  }
});

export default css;



// WEBPACK FOOTER //
// ./src/js/module/css.js